
export default function TestimonialsSection() {
  const testimonials = [
    {
      type: '売却側',
      name: '飲食店チェーン 代表取締役',
      company: '東京都',
      comment: '長年経営してきた店舗を手放すのは不安でしたが、NEXTAGEのサポートのおかげで、理想的な買手と出会うことができました。スタッフの雇用も守られ、安心して引き継ぐことができました。',
      rating: 5
    },
    {
      type: '買収側',
      name: 'IT企業 経営企画部長',
      company: '神奈川県',
      comment: '事業拡大のため、技術力のある企業を探していました。NEXTAGEの的確なマッチングにより、当社のニーズにぴったりの企業と出会えました。デューデリジェンスも丁寧にサポートいただき、スムーズに買収を完了できました。',
      rating: 5
    },
    {
      type: '売却側',
      name: '美容室チェーン オーナー',
      company: '大阪府',
      comment: '後継者問題で悩んでいましたが、NEXTAGEに相談して本当に良かったです。わずか2ヶ月で成約し、スタッフも全員継続雇用してもらえました。売却後も順調に営業を続けているようで安心しています。',
      rating: 5
    },
    {
      type: '買収側',
      name: 'EC事業者 代表取締役',
      company: '東京都',
      comment: '新規事業として実績のあるECサイトを探していました。NEXTAGEの紹介案件は質が高く、財務状況も透明性があり、安心して買収を決断できました。買収後の引き継ぎサポートも手厚く、大変助かりました。',
      rating: 5
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">お客様の声</h2>
          <p className="text-lg text-gray-600">成約されたお客様からいただいた喜びの声</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center justify-between mb-4">
                <span className={`px-4 py-1 rounded-full text-sm font-medium ${
                  testimonial.type === '売却側' 
                    ? 'bg-teal-100 text-teal-700' 
                    : 'bg-blue-100 text-blue-700'
                }`}>
                  {testimonial.type}
                </span>
                <div className="flex gap-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
              </div>

              <p className="text-gray-700 leading-relaxed mb-6 italic">
                「{testimonial.comment}」
              </p>

              <div className="border-t pt-4">
                <p className="font-bold text-gray-900">{testimonial.name}</p>
                <p className="text-sm text-gray-600">{testimonial.company}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
